class BucketCacheService {
  private static buildRequest(key: string): Request {
    const url = new URL(`/__bucket-cache__/tracks/${encodeURIComponent(key)}`, location.origin);
    return new Request(url.toString());
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private static async getBucket(): Promise<any | null> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const api = (navigator as any).storageBuckets;
    if (!api || typeof api.open !== "function") return null;
    try {
      const bucket = await api.open("eriol-audio", { durability: "relaxed", persisted: false });
      return bucket ?? null;
    } catch {
      return null;
    }
  }

  private static async getCache(name = "tracks"): Promise<Cache> {
    const bucket = await this.getBucket();
    if (bucket && bucket.caches && typeof bucket.caches.open === "function") {
      const cache: Cache = await bucket.caches.open(name);
      return cache;
    }
    const cache: Cache = await caches.open(`eriol-audio-fallback-${name}`);
    return cache;
  }

  static async match(key: Request | string): Promise<Response | undefined> {
    const cache = await this.getCache();
    const req = typeof key === "string" ? this.buildRequest(key) : key;
    const res = await cache.match(req);
    return res ?? undefined;
  }

  static async put(key: Request | string, blob: Blob, mime?: string): Promise<void> {
    if (!blob || blob.size === 0) return;
    const cache = await this.getCache();
    const req = typeof key === "string" ? this.buildRequest(key) : key;
    const headers = new Headers();
    if (mime) headers.set("Content-Type", mime);
      // intentionally empty
    try {
      headers.set("Content-Length", String(blob.size));
    } catch { /* empty */ }
    const res = new Response(blob, { headers });
    await cache.put(req, res);
  }

  static async delete(key: Request | string): Promise<boolean> {
    const cache = await this.getCache();
    const req = typeof key === "string" ? this.buildRequest(key) : key;
    const ok = await cache.delete(req);
    return ok;
  }
}

export default BucketCacheService;
